import { useEffect, useState } from "react"
import styles from "./styles.module.scss"
import { Badge, Menu, Space } from "antd"
import Logo from "components/logo"
import UserSettings from "components/user-settings"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ReactComponent as CartIcon } from "assets/icons/cart.svg"
import CircleButton from "@atoms/icon-button"
import { useMemberId } from "pages/member"
import Notifications from "./notification"
import { useCart } from "../../../../pages/cart/queries"

export interface IHeader extends React.PropsWithChildren {
  items?: any[]
}

const Header: React.FC<IHeader> = ({ children, items }) => {
  const navigate = useNavigate()
  const memberId = useMemberId()
  const [sticky, setSticky] = useState(false)
  const location = useLocation()
  useEffect(() => {
    const scrollHandler = () =>
      setSticky(document.documentElement.scrollTop > 54)
    document.addEventListener("scroll", scrollHandler)
    return () => document.removeEventListener("scroll", scrollHandler)
  }, [setSticky])
  const getSelectedTab = () => {
    const path = location.pathname.split("/")
    const keys = items?.map((item) => item.key)
    return path.filter((value) => keys?.includes(value))
  }
  getSelectedTab()

  const cart = useCart(memberId)
  return (
    <>
      <nav className={styles.menu_nav}>
        <Link to="/" style={{ display: "flex" }}>
          <Logo />
        </Link>
        <div>
          <Space size="middle" align="center">
            {location.pathname !== "/" && (
              <Badge count={cart.data?.length}>
                <CircleButton
                  icon={<CartIcon />}
                  onClick={() => navigate(`/members/${memberId}/cart`)}
                />
              </Badge>
            )}
            <Notifications />
            <UserSettings />
          </Space>
        </div>
      </nav>
      {items && (
        <nav className={styles.submenu__wrapper}>
          <div
            className={`${styles.submenu} ${
              sticky ? styles.submenu_sticky : ""
            }`}
          >
            <div className={styles.submenu__inner}>
              <Menu
                style={{ width: "100%" }}
                selectedKeys={getSelectedTab()}
                mode="horizontal"
                items={items}
              />
            </div>
          </div>
        </nav>
      )}

      {children}
    </>
  )
}

export default Header
